export class ShareLinkInfo {
  message: string="";
  status:string="";
}

export default ShareLinkInfo